import { useFormat } from '@ideavivat/vivat-2';
import useSisahygo from '@/useSisahygo';

const { statusClassMap } = useSisahygo();

/* eslint-disable */
export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    tracking_no: {
      name: 'Tracking No.',
      width: '9rem',
      class: 'text-left',
    },
    order_header_no: {
      name: 'Order No.',
      width: '9rem',
      class: 'text-left',
    },
    order_header_date: {
      name: 'วันที่',
      width: '8rem',
      class: 'text-center',
      filter: (val: string | null) => val ? useFormat.date(val).displayShortThaiDate() : '-',
    },
    order_status: {
      name: 'สถานะ',
      width: '10rem',
      class: {
        text(val: string) {
          return statusClassMap(val);
        },
      },
    },
    order_type: {
      name: 'ประเภท',
      width: '7rem',
      class: 'text-center',
      filter: (val: string | null) => val || '-',
    },
    order_amount: {
      name: 'มูลค่า',
      width: '8rem',
      class: 'text-right mr-3',
      filter: (val: number | null) => val != null
        ? val.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : '-',
    },
    branch: {
      name: 'ต้นทาง',
      width: '8rem',
      class: 'text-center',
      filter: (val: string | null) => val || '-',
    },
    branch_rec: {
      name: 'ปลายทาง',
      width: '8rem',
      class: 'text-center',
      filter: (val: string | null) => val || '-',
    },
    customer: {
      name: 'ผู้ส่ง',
      width: '12rem',
      class: 'text-left',
      filter: (val: string | null) => val || '-',
    },
    customer_rec: {
      name: 'ผู้รับ',
      width: '12rem',
      class: 'text-left',
      filter: (val: string | null) => val || '-',
    },
  },
  sortable: [
    'tracking_no',
    'order_header_no',
    'order_header_date',
    'order_status',
    'order_amount',
  ],
};
